import React from "react";
import { Typewriter } from 'react-simple-typewriter';
import ScrollService from "../../../utilities/ScrollService";
import "./Profile.css";

export default function Profile() {
  return (
    <div className="profile-container">
      <meta name="google-site-verification" content="O-j86M6wYwcz_Ll16-c2iezkvpUDp3WCKHEIahf3ykk" />
      <div className="profile-parent">
        <div className="profile-details">
          <div className="colz">
            <div className="colz-icon">
              <a href="https://github.com/teluremahendra">
                <i className="fa fa-github" />
              </a>
              <a href="https://www.linkedin.com/in/telureMahendra/">
                <i className="fa fa-linkedin-square" />
              </a>
              <a href="https://www.instagram.com/teluremahendra/">
                <i className="fa fa-instagram" />
              </a>
              <a href="https://www.youtube.com/@techmahendra.Official">
                <i className="fa fa-youtube-square" />
              </a>

            </div>
          </div>
          <div className="profile-details-name">
            <span className="primary-text">
              {" "}
              Hello, I'M <span className="highlighted-text">Mahendra</span>
            </span>
          </div>
          <div className="profile-details-role">
            <span className="primary-text">
              {" "}
              <h1>

                <Typewriter
                  words={[
                    'Enthusiastic Dev 😎',
                    'Fullstack Developer💻',
                    'JAVA Dev 🌐',
                    'Fluter 📱',
                  ]}
                  loop={0} // 0 = Infinity
                  cursor
                  cursorStyle="|"
                  typeSpeed={70}
                  deleteSpeed={50}
                  delaySpeed={1000}
                />



                {/* <Typical
                  loop={Infinity}
                  steps={[
                    "Enthusiastic Dev 😎",
                    1000,
                    "Fullstack Developer💻",
                    1000,
                    "JAVA Dev 📱",
                    1000,
                    "React 🌐",
                    1000,
                  ]}
                /> */}
              </h1>
            </span>
            <span className="profile-role-tagline">
              Knack of building applications with front and back end operations.
            </span>
          </div>

          <div className="profile-options">
            <button className="btn primary-btn"
              onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
            > Hire Me </button>
            <a href="mahiResume1.pdf" download="Mahendra Telure Resume.pdf">
              <button className="btn highlighted-btn">Get Resume</button>
            </a>
          </div>
        </div>
        <div className="profile-picture">
          <div className="profile-picture-background"></div>
        </div>
      </div>
    </div>
  );
}
